import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'
import SearchResponsavel from '@/components/SearchResponsavel.vue'
import {RelatorioEntrega} from '@/model/resource/RelatorioEntrega'

export class InputRelatorioEntregaSchema extends Schema {
  collectionResponsavel = new ResponsavelCollection().noPagination()

  readonly name = 'InputRelatorioEntrega'

  formFields = ['periodoInicial', 'periodoFinal']

  readonly fieldSet: FieldSet<RelatorioEntrega> = {
    responsavel: (schema): FieldComponent => ({
      is: SearchResponsavel,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'col-span-2',
        collection: this.collectionResponsavel,
        noResultLabel: this.translateFrom('noResultLabel'),
        noOptionsLabel: this.translateFrom('noOptionsLabel'),
        required: true,
      },
    }),
    periodoInicial: (schema): FieldComponent => ({
      is: Component.InputDate,
      bind: {
        label: this.translateFrom(schema.fieldName),
        required: true,
      },
    }),
    periodoFinal: (schema): FieldComponent => ({
      is: Component.InputDate,
      bind: {
        label: this.translateFrom(schema.fieldName),
        required: false,
      },
    }),
  }
}
